// extracted by mini-css-extract-plugin
export var blink = "_8t-2";
export var cursor = "_8t-1";
export var reactMarkdown = "_8t-3";
export var streamingText = "_8t-0";